import './registerServiceWorker'
import Vue from 'vue'
import vueHeadful from 'vue-headful'
import App from './App'
import router from './router'
import store from './store/index'
import Fader from './components/Fader'
import Icon from './components/Icon'
import firebase from '@/utilities/firebase-config'
import { initGlobalWarnHandlerForVue } from './utilities/debugging'

Vue.component(`vue-headful`, vueHeadful)
Vue.component(`fader`, Fader)
Vue.component(`icon`, Icon)

Vue.prototype.$styles = {}

let app = null

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: h => h(App),
    }).$mount(`#app`)
  }

  if (window.Cypress) {
    // only available during E2E tests
    window.myApp = app
  }
})

initGlobalWarnHandlerForVue(Vue, console.error)
